import TopicTwo from "../../../components/platform-contents/pips-terminal-contents/TopicTwo";

const PipsTerminalContentFive = () => {
  return (
    <>
      {/* <TopicTwo /> */}

      <div className="how__work__platform">
        <div className="quality-section-market">
          <div className="quality-header-market">
            <h1>Why Trade on The Pips Terminal</h1>
            <p>
              Purpose-built by traders for traders, The Pips Terminal delivers
              the balance of simplicity and sophistication that today’s market
              demands.
            </p>
          </div>
        </div>
        <div className="container">
          <div className="contact__cards row">
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Tailored for Performance</h4>
                </div>
                <p>
                  Trade multiple assets with real-time execution and unmatched
                  stability.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Deep Insights, Simplified</h4>
                </div>
                <p>
                  Visual analytics and predictive tools help you see
                  opportunities clearly.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Secure by Design</h4>
                </div>
                <p>
                  Protected by bank-grade encryption and advanced compliance
                  standards.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PipsTerminalContentFive;
